<template>
  <div class="life_costs-pages-pay-payList content-container" id="life_costs-pages-pay-payList">
    <div class="container-scroll">
        <form name="loginform" id="formExport" action method="post" target="_blank">
            <input type="hidden" id="mchGroupCode" name="mchGroupCode" />
            <input type="hidden" id="mchSiteNo" name="mchSiteNo" />
            <input type="hidden" id="mchOrderNo" name="mchOrderNo" />
            <input type="hidden" id="mchOrderDttm" name="mchOrderDttm" />
            <input type="hidden" id="goodsTitle" name="goodsTitle" />
            <input type="hidden" id="goodsDetail" name="goodsDetail" />
            <input type="hidden" id="orderAmount" name="orderAmount" />
            <input type="hidden" id="chnlMchCode" name="chnlMchCode" />
            <input type="hidden" id="chnlMchName" name="chnlMchName" />
            <input type="hidden" id="mchCustId" name="mchCustId" />
            <input type="hidden" id="mchCustName" name="mchCustName" />
            <input type="hidden" id="mchCustIp" name="mchCustIp" />
            <input type="hidden" id="mchCustMac" name="mchCustMac" />
        </form>
        <!--导航部分-->
        <section class="layout-pad-full layout-margin-bottom back-white">
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item>生活中心</a-breadcrumb-item>
                <a-breadcrumb-item>缴费列表</a-breadcrumb-item>
            </a-breadcrumb>
        </section>
        <!--导航部分 end-->
        <!--search部分-->
        <section class="layout-pad-full layout-pad-top-nil layout-margin-bottom back-white">
            <h1 class="holder-title">搜索条件</h1>
            <a-form class="cabinvue-search-form">
                <a-row :gutter="24">
                    <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                        <div class="search-form-item">
                            <div class="item-label">
                                <span>项目名称：</span>
                            </div>
                            <div class="item-control">
                                <a-input v-model="condition.communityName" placeholder="请输入项目名称" />
                            </div>
                        </div>
                    </a-col>
                    <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                        <div class="search-form-item">
                            <div class="item-label">
                                <span>支付类型：</span>
                            </div>
                            <div class="item-control">
                                <a-select 
                                  show-search
                                  placeholder="请选择支付类型"
                                  option-filter-prop="children"
                                  :filter-option="filterOption"
                                  allow-clear
                                  v-model="condition.payTypeNo">
                                    <a-select-option v-for="item in paymentEnumList" :key="item.code"
                                        :value="item.code">{{item.value}}
                                    </a-select-option>
                                </a-select>
                            </div>
                        </div>
                    </a-col>
                    <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                        <div class="search-form-item">
                            <div class="item-label">
                                <span>支付状态：</span>
                            </div>
                            <div class="item-control">
                                <a-select 
                                  show-search
                                  placeholder="请选择支付状态"
                                  option-filter-prop="children"
                                  :filter-option="filterOption"
                                  allow-clear
                                  v-model="condition.payStatus">
                                    <a-select-option v-for="(statusItem,statusInd) in statusList" :key="statusInd"
                                        :value="statusItem.code">{{statusItem.value}}
                                    </a-select-option>
                                </a-select>
                            </div>
                        </div>
                    </a-col>
                    <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                        <div class="search-form-item">
                            <div class="item-label">
                                <span>费算ID：</span>
                            </div>
                            <div class="item-control">
                                <a-input v-model="condition.businessId" placeholder="请输入费算ID" />
                            </div>
                        </div>
                    </a-col>
                    <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                        <div class="search-form-item">
                            <div class="item-label">
                                <span>三方单号：</span>
                            </div>
                            <div class="item-control">
                                <a-input v-model="condition.thirdPayNo" placeholder="请输入三方单号" />
                            </div>
                        </div>
                    </a-col>
                    <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                        <div class="search-form-item">
                            <div class="item-label">
                                <span>订单号：</span>
                            </div>
                            <div class="item-control">
                                <a-select
                                  allow-clear
                                  mode="tags"
                                  placeholder="请输入订单号"
                                  v-model="condition.payOrderNo"
                                ></a-select>
                            </div>
                        </div>
                    </a-col>
                </a-row>
                <hr />
                <div class="form-option-area">
                    <a-button icon="search" class="space-margin-right" type="primary" :loading="tableObj.tableLoading"
                        @click.stop="search">查询</a-button>
                    <a-button icon="reload" class="space-margin-right btn-outline" @click.stop="resetEvt">重置</a-button>
                </div>
            </a-form>
        </section>
        <!--search部分 end-->
        <!--表格部分-->
        <section class="layout-pad-full layout-margin-bottom back-white">
            <a-table 
              @expand="expandTableEvt" 
              :expanded-row-keys="tableObj.expandedRowKeys" 
              :scroll="tableObj.scroll"
              class="J_compensation_list_table" 
              :columns="tableObj.columns" 
              :data-source="tableObj.list"
              :pagination="false" 
              :loading="tableObj.tableLoading" 
              >
                <template slot="action" slot-scope="text, record">
                  <a href="javascript:;" @click="queryList(record)">查询</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="againPay(record)" :disabled="record.flag !== '85'">再次缴费</a>
                </template>
                <template slot="expandedRowRender" slot-scope="record, index, indent, expanded">
                    <a-row class="expanded-row" :gutter="24" v-for="(item,index) in children" :key="index">
                        <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                            <p class="detail-para">订单号：{{item.payOrderNo}}</p>
                        </a-col>
                        <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                            <p class="detail-para">账单名称：{{item.billName}}</p>
                        </a-col>
                        <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                            <p class="detail-para">账单金额：{{item.billAmt}}</p>
                        </a-col>
                        <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                            <p class="detail-para">创建人：{{item.createUser}}</p>
                        </a-col>
                        <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                            <p class="detail-para">创建时间：{{item.createTime}}</p>
                        </a-col>
                        <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                            <p class="detail-para">更新人：{{item.updateUser}}</p>
                        </a-col>
                        <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                            <p class="detail-para">更新时间：{{item.updateTime}}</p>
                        </a-col>
                    </a-row>
                </template>
            </a-table>
            <div class="clearfix">
                <a-pagination style="margin-top:8px;float: right;" show-size-changer @change="pagination.change"
                    @showSizeChange="pagination.showSizeChange" :default-current="pagination.defaultCurrent"
                    v-model="pagination.current" :defaultPageSize="pagination.defaultPageSize" :total="pagination.total"
                    :show-quick-jumper="pagination.showQuickJumper" :page-size-options="pagination.pageSizeOptions"
                    :show-total='pagination.showTotal'>
                </a-pagination>
            </div>
        </section>
        <!--表格部分 end-->
    </div>
  </div>
</template>

<script>
import ajax from '../../lib/axios/ajax'
import { POST_PAYBILL_QUERYBILLRECORDSLIST, POST_PAYBILL_QUERYBILLRECORDSDETAIL,POST_PAYBILL_AGAINPAYORDER,
 POST_PAYBILL_GETPAYPAPER, POST_PAYBILL_QUERYPAYSTATEENUM, POST_PAYBILL_QUERYPAYORDERINFO } from '../../lib/axios/apilist'

export default {
//这里必须 使用一个方法返回给data
  data: function () {
    // 请求地址
    let ajaxParam = {
      POST_PAYBILL_QUERYBILLRECORDSLIST: POST_PAYBILL_QUERYBILLRECORDSLIST,
      POST_PAYBILL_QUERYBILLRECORDSDETAIL: POST_PAYBILL_QUERYBILLRECORDSDETAIL,
      POST_PAYBILL_AGAINPAYORDER: POST_PAYBILL_AGAINPAYORDER,
      POST_PAYBILL_GETPAYPAPER: POST_PAYBILL_GETPAYPAPER,
      POST_PAYBILL_QUERYPAYSTATEENUM: POST_PAYBILL_QUERYPAYSTATEENUM,
      POST_PAYBILL_QUERYPAYORDERINFO: POST_PAYBILL_QUERYPAYORDERINFO,
    };
    //分页信息
    let pagination = {
      pageSize: 10,
      current: 1,
      defaultCurrent: 1,
      defaultPageSize: 10,
      total: 0,
      showQuickJumper: true,
      showTotal: total => `共${total}条数据`,
      showSizeChanger: true,
      pageSizeOptions: ['10', '30', '50', '100'],
      showSizeChange: (current, pageSize) => {
        this.pagination.pageSize = pageSize;
        this.pagination.current = current;
        this.$options.methods.search.bind(this)();
      },
      change: (page, pageSize) => {
        this.pagination.current = page;
        this.pagination.pageSize = pageSize;
        this.$options.methods.search.bind(this)(false);
      }
    };

    let condition = {
      communityName: undefined, // 项目名称
      payTypeNo: undefined, //  支付类型
      payOrderNo: [], //  订单号arr
      payStatus: undefined, // 支付状态 
      businessId: undefined, // 批次号
      thirdPayNo: undefined, // 三方单号
    }
    let tableObj = {
      tableLoading: false,
      expandedRowKeys: [],
      list: [],
      scroll: {
        x: 1000,
      },
      columns: [{
        title: '项目名称',
        dataIndex: 'communityName',
      },{
        title: '订单号',
        dataIndex: 'payOrderNo',
      },{
        title: '三方支付单号',
        dataIndex: 'thirdPayNo',
      },{
        title: '支付状态',
        dataIndex: 'payStatusName',
      },{
        title: '支付金额',
        dataIndex: 'payAmt',
      },{
        title: '支付类型',
        dataIndex: 'payTypeNoName',
      },{
        title: '创建时间',
        dataIndex: 'createTime',
      },{
        title: '操作',
        dataIndex: 'action',
        fixed: 'right',
        scopedSlots: {
          customRender: 'action'
        },
      }
    ]
    }
    return {
      pagination,
      paymentEnumList: [],
      statusList: [],
      condition,
      tableObj,
      ajaxParam,
      children: [],
    }
  },
  beforeRouteEnter (to, from, next) {
    
    next(vm => {
      // 通过 `vm` 访问组件实例
      if(from.path === '/pay/unpaid' && to.query.payOrderNo){
        vm.condition.payOrderNo = JSON.parse(to.query.payOrderNo)
      }
      vm.initFunc()
    })
  },
  mounted() {
    //进入页面
    //cabinVue 里面所有的this 都指向当前这个vue 实例
    //vue 更多使用方法请查看vue官方文档
    this.$nextTick(function () {
      //nextTick 用于当data数据改变,触发vue 渲染,且渲染完毕使用

    });
  },
  //如果 不需要保存页面状态必须添加下面这个方法
  beforeDestroy: function () {
    
  },
  destroyed: function () {
    //离开页面方法
    
  },
  //监听属性变化，，变量必须是data里声明的
  watch: {
    'condition.payDateScope': function (value) {
      if (value === '0') {
        this.resetEvt()
      }
    }
  },
  //监听属性变化，配置变量的同时也起到data声明的作用
  computed: {},
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    previousPageEvt() {
      this.$router.go(-1)
    },
    //   选择支付状态
    statushandleChange() {
    },
    initFunc(){
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_QUERYPAYSTATEENUM;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.statusList = res.data.statusList;
          this.paymentEnumList = res.data.paymentEnumList;
          
          this.$options.methods.search.bind(this)();
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    // table查询搜索
    search(startFlag = true, param = {}, tempPagination = this.pagination) {
    
      let searchParam = {
        ...this.condition
      }
      // 开启加载效果
      this.tableObj.tableLoading = true;
      //浅复制
      let requestParam = Object.assign({}, searchParam, param);
      let currentPageNo = tempPagination.current;
      let currentPageSize = tempPagination.pageSize;
      if (startFlag) {
        requestParam.currentPage = 1;
      } else {
        requestParam.currentPage = currentPageNo;
      }
      requestParam.pageSize = currentPageSize;

      // 清空table数据
      this.tableObj.list.splice(0, this.tableObj.list.length);
      // this.tableObj.expandedRowKeys.splice(0, this.tableObj.expandedRowKeys.length);

      let that = this;
      let successFunc = (res) => {
        // 关闭加载效果
        this.tableObj.tableLoading = false;
        if (res.code === "0000") {
          this.pagination.current = res.data.page.currentPage;
          this.pagination.defaultCurrent = res.data.page.currentPage;
          this.pagination.pageSize = res.data.page.pageSize;
          this.pagination.total = res.data.page.totalCount;
          this.tableObj.list = res.data.page.result.map(item => {
            return {
              ...item,
              children: []
            }
          }) || [];
          // this.statusList = res.data.statusList;
          //调整TABLE样式
          that.$nextTick(function () {
            //根据表格实际宽度设置scrollX
            that.tableObj.scroll.x = 200 * that.tableObj.columns.length;
          });
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.tableObj.tableLoading = false;
        this.$error({
          title: '提示',
          content: res.result,
        });
      };

      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_QUERYBILLRECORDSLIST;
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    },
    resetEvt() {
      this.condition = {
        communityName: undefined, // 项目名称
        payTypeNo: undefined, //  支付类型
        payOrderNo: [], //  订单号arr
        payStatus: undefined, // 支付状态 
        businessId: undefined, // 批次号
        thirdPayNo: undefined, // 三方单号
      }
      // this.pageData.payDate = [];
    },
    payDateChange(date, dateString) {
      if (dateString) {
        this.condition.payDateStart = dateString[0]; // 处理时间开始
        this.condition.payDateEnd = dateString[1]; // 处理时间结束
      } else {
        //   this.pageData.payDate = [];
      }
    },
    expandTableEvt(expanded, record) {
      if (expanded) {
        this.detailEvt(record.payOrderNo)
      } else {
        this.tableObj.expandedRowKeys = []
      }
    },
    detailEvt(payOrderNo) {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_QUERYBILLRECORDSDETAIL;
      let successFunc = (res) => {
        if (res.code === "0000") {
          
          this.tableObj.list.find((item, index) => {
            
            if (item.payOrderNo === payOrderNo) {
              this.tableObj.expandedRowKeys = [index]
              this.children = res.data
              return true
            }else{
              return false
            }
          })
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        payOrderNo: payOrderNo, // 订单号
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    },
    //   查询方法
    queryList(item) {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_QUERYPAYORDERINFO;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.$success({
            title: '提示',
            content: (res.result),
            onOk: () => {
              this.search();
            }
          });
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        payOrderNo: item.payOrderNo, // 订单号
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    //   再次缴费
    againPay(item) {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_AGAINPAYORDER;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.getPayPaper(res.data);
          this.$options.methods.search.bind(this)();
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        payOrderNo: item.payOrderNo, // 订单号
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    // // 获取支付页面
    getPayPaper(params) {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_GETPAYPAPER;
      const formdom = document.getElementById("formExport");
      formdom.action = url;
      document.getElementById("mchGroupCode").value = params.mchGroupCode;
      document.getElementById("mchSiteNo").value = params.mchSiteNo;
      document.getElementById("mchOrderNo").value = params.mchOrderNo;
      document.getElementById("mchOrderDttm").value = params.mchOrderDttm;
      document.getElementById("goodsTitle").value = params.goodsTitle;
      document.getElementById("goodsDetail").value = params.goodsDetail;
      document.getElementById("orderAmount").value = params.orderAmount;
      document.getElementById("chnlMchCode").value = params.chnlMchCode;
      document.getElementById("chnlMchName").value = params.chnlMchName;
      document.getElementById("mchCustId").value = params.mchCustId;
      document.getElementById("mchCustName").value = params.mchCustName;
      document.getElementById("mchCustIp").value = params.mchCustIp;
      document.getElementById("mchCustMac").value = params.mchCustMac;
      document.loginform.submit();
    }
  }
}
</script>

<style scoped>

</style>